/* RESPONSIBLE TEAM: team-reporting */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class DateRange extends Fragment {
  @attr('string') selection;
  @attr('date') start;
  @attr('date') end;
}
